const getDurationString = (duration: number): string | null => {
  if (!duration) {
    return null;
  }

  let result = '';

  const hours = Math.floor(((duration % 31536000) % 86400) / 3600);
  const minutes = Math.floor((((duration % 31536000) % 86400) % 3600) / 60);

  if (hours) {
    result += hours + 'h';
  }

  if (minutes) {
    if (hours) {
      result += ' ';
    }

    result += minutes + ' m';
  }

  return result;
};

export default getDurationString;
